import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import './plan.css';

/** The "premium" crown shown next to a feature the current plan doesn't include. */
const PlanCrown: React.FC<{ className?: string; title?: string }> = ({ className, title }) => {
    const { t } = useTranslation();
    return (
        <FontAwesomeIcon
            icon={faCrown}
            className={`gs-plan-crown ${className ?? ''}`}
            title={title ?? t('plan.crownTitle')}
            aria-label={title ?? t('plan.crownTitle')}
        />
    );
};

export default PlanCrown;
